<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" sm="6">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>

                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="options.debounce" placeholder="Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Enabled?" label-for="enabled" label-cols="12">
                  <treeselect instanceId="enabled" type="number" v-model="enabled" :clearable="true"
                    :options="enabled_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="options.debounce" placeholder="Category"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in tools.filter(
                    (o) => o.position == 'toolbar'
                  )" :key="index">
                    <b-button v-if="tool.type == 'button'" :id="'tool_' + tool.action" :size="tool.size"
                      :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null" :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)">
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col cols="auto" v-for="(tool, index) in options.view" :key="index">
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group v-if="tool.type == 'radio-group'" :options="tool.options">
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay :show="options.overlay_show" rounded="sm" opacity="0.6" v-click-outside="outside">
            <div>
              <b-table :dark="$store.state.darkMode" ref="btable" :sticky-header="btable_height + 'px'" striped hover
                small caption-bottom show-empty selectable select-mode="multi" :busy="btable_busy" :items="btable_items"
                :filter="btable_find" :fields="options.fields" @row-selected="btable_rowSelected">
                <template #head(selected)>
                  <i id="selectall" class="ml-1" :class="btable_iconselected()" aria-hidden="true"
                    @click="btable_iconselectedClick()" title="Click to select/unselect all"></i>
                  <b-tooltip target="selectall" triggers="hover" placement="right">Click to select/unselect
                    all</b-tooltip>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>
                <template v-slot:cell(days)="slot">
                  {{ daysofweek(slot.item.days) }}
                </template>

                <template v-slot:cell()="row">
                  <div v-if="options.badges &&
                    options.badges.find((obj) => obj.key == row.field.key)
                    ">
                    <span v-html="btable_rowBadgeCell(
                      row.item,
                      options.badges.find(
                        (obj) => obj.key == row.field.key
                      ),
                      options
                    )
                      "></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button variant="link" size="sm" title="Actions" :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')">
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover container="actions-container" triggers="click blur" placement="leftbottom"
                      :target="'popover-target-' + row.item.id">
                      <div>
                        <b-nav vertical>
                          <b-nav-item :title="action.label" v-for="action in btable_rowActionCell(
                            row.item,
                            options
                          )" :key="action.key" @click.stop="btable_rowClick(action.key, row)">
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="btable_rowActionIcon(action, row.item)
                                    "></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button variant="link" size="sm" v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key" @click.stop="btable_rowClick(action.key, row)" :title="action.label">
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component :is="options.component.name" :selection="btable_selected" :config="cconfig"
                      @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button v-for="(button, index) in options.overlay.buttons" :key="index"
                      :style="button.style ? button.style : 'width: 80px'" :class="button.class
                          ? button.class
                          : button.dispatch
                            ? null
                            : 'ml-2'
                        " :variant="button.variant
      ? button.variant
      : button.dispatch
        ? 'outline-primary'
        : 'outline-secondary'
    " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                        ">{{ button.label }}</b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="btable_selected" :config="cconfig" @saveit="saveit"
          @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3" no-gutters>
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary ml-1">Found {{ rows }} rows</span>
        </b-col>
        <b-col class="text-right">
          <b-pagination hide-ellipsis v-model="currentpage" :total-rows="rows" :per-page="limit" align="right"
            size="sm"></b-pagination>
        </b-col>
        <b-col class="ml-2" cols="auto">
          <div class="pagelimit">
            <treeselect v-model="limit" :clearable="false" :options="options_pagesizes" size="sm" inline></treeselect>
          </div>
        </b-col>
      </b-row>
      <b-card-footer class="text-primary">
        <span v-html="message"></span>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import TaskSchedulerEdit from "./Components/TaskSchedulerEdit";
import TaskSchedulerAudit from "./Components/TaskSchedulerAudit";

export default {
  name: "TaskScheduler",
  components: { TaskSchedulerEdit, TaskSchedulerAudit },
  watch: {
    async name() {
      await this.load();
    },
    async category() {
      await this.load();
    },
    async enabled() {
      await this.load();
    },
  },
  data() {
    return {
      busy: false,
      name: null,
      enabled: null,
      enabled_options: [
        {
          id: "true",
          label: "Yes",
        },
        {
          id: "false",
          label: "No",
        },
      ],
      category: null,
      message: "",
      options: {
        title: "Task Scheduler",
        icon: "fa fa-clock-o pl-2",
        debounce: 500,
        tools: [],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          {
            key: "name",
            label: "Name",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "enabled",
            label: "Enabled",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "datestart_df",
            label: "Date Start",
            class: "d-none d-sm-table-cell",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "dateend_df",
            label: "Date End",
            class: "d-none d-sm-table-cell",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "days",
            label: "Days",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "at",
            label: "At",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "repeat",
            label: "Every",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "text-right",
            formatter: (value, key, item) => {
              if (parseInt(value) > 0) {
                return value + " min";
              } else {
                return "";
              }
            },
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "datelast_df",
            label: "Date Last",
            class: "d-none d-sm-table-cell",
            sortable: true,
          },
          {
            key: "lastmessage",
            label: "Last polled state",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "running",
            label: "State",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-120px",
          },
        ],
        badges: [
          {
            key: "enabled",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value) {
                return "Yes";
              } else {
                return "No";
              }
            },
          },
          {
            key: "running",
            type: "badge",
            Idle: "success",
            Running: "danger",
            formatter: (value, key, item) => {
              if (value == "1") {
                return "Running";
              } else if (value == "0") {
                return "Idle";
              } else {
                return "";
              }
            },
          },
        ],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "TaskSchedulerEdit",
            },
          },
          // {
          //   key: "audit",
          //   label: "Audit",
          //   icon: "fa fa-history text-warning",
          //   single: true,
          //   multiple: false,
          //   component: {
          //     name: "TaskSchedulerAudit",
          //   },
          // },
          {
            key: "runnow",
            label: "Run Now",
            icon: "fa fa-play",
            single: true,
            multiple: false,
            method: {
              name: "statechange",
              args: "1",
            },
          },
          {
            key: "stopnow",
            label: "Stop Now",
            icon: "fa fa-stop text-danger",
            single: true,
            multiple: false,
            method: {
              name: "statechange",
              args: "0",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    // if (this.user.permissions.includes("clientemails.delete")) {
    this.options.actions.push({
      key: "delete",
      label: "Delete",
      icon: "fa fa-trash text-danger",
      single: true,
      multiple: true,
      overlay: {
        message: "Are you sure you want to delete row %id% ?",
        buttons: [
          {
            label: "Yes",
            variant: "danger",
            dispatch: "delete",
          },
          {
            label: "No",
            class: "ml-2",
          },
        ],
      },
    });
    // }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    this.toolComponents([
      { action: "add", name: "TaskSchedulerEdit" },
      { action: "edit", name: "TaskSchedulerEdit" },
    ]);

    // this.loadDDL();
    this.load();
  },

  methods: {
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }
      this.btable_items = [];
      this.btable_busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        name: this.name,
        category: this.category,
        enabled: this.enabled,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasksAt_mssql(
              $limit: Int
              $offset: Int
              $name: String
              $category: String
              $enabled: String
              $dateformat: String
            ) {
              tasksAt_mssql(
                limit: $limit
                offset: $offset
                name: $name
                category: $category
                enabled: $enabled
                dateformat: $dateformat
              ) {
                id
                enabled
                name
                api
                datelast_df
                datestart_df
                dateend_df
                days
                at
                repeat
                category
                data
                lastmessage
                priority
                running
                runnow
                rows
              }
            }
          `,
          variables,
        });

        if (limit > this.limit) {
          return response.data.users_mssql;
        }

        this.btable_items = response.data.tasksAt_mssql;
        if (response.data.tasksAt_mssql.length > 0) {
          this.rows = response.data.tasksAt_mssql[0].rows;
        }
      } catch (error) {
        console.log(error);
      }

      this.btable_busy = false;
      this.message = "";
    },

    async _toolClick(a) {
      console.log("local toolClick: ", a);
      switch (a) {
        case "runnow":
          await this.changestate("1");
          break;
        case "stopnow":
          await this.changestate("0");
          break;
      }
    },

    async deleteit() {
      let variables = {
        rows: this.cleanit(this.selected),
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tasksAt_delete_mssql($rows: [TasksAt_input]) {
              tasksAt_delete_mssql(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },

    async changestate(s) {
      console.log("state change", s);

      let rows = [
        this.$helpers.prepareforSave({
          id: this.idselected,
          runnow: s,
        }),
      ];

      let variables = { rows };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tasksAt_save_mssql($rows: [TasksAt_input]) {
              tasksAt_save_mssql(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message =
          "<span class='text-warning'>" +
          "The task will be changed as soon as possible at the next backoffice checkpoint." +
          "</span>";
        //   this.items[].name +
        //   " task will be %changed% " +
        //   " as soon as possible at the next backoffice checkpoint.";
        // if (value == "1") {
        //   this.message =
        //     "<span class='text-warning'>" +
        //     this.message.split("%changed%").join("started") +
        //     "</span>";
        // } else {
        //   this.message =
        //     "<span class='text-danger'>" +
        //     this.message.split("%changed%").join("stopped") +
        //     "</span>";
        // }
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
    },

    daysofweek(a) {
      let result = "";
      if (!a) {
        return result;
      }
      let days = JSON.parse(a);
      if (days.includes(1)) {
        result += " Mo";
      }
      if (days.includes(2)) {
        result += " Tu";
      }
      if (days.includes(3)) {
        result += " We";
      }
      if (days.includes(4)) {
        result += " Th";
      }
      if (days.includes(5)) {
        result += " Fr";
      }
      if (days.includes(6)) {
        result += " Sa";
      }
      if (days.includes(0)) {
        result += " Su";
      }
      return result.trim();
    },
  },
};
</script>

<style></style>